import { useLenis } from "../hooks/useLenis";
import { Nav } from "../components/portfolio/Nav";
import { Hero } from "../components/portfolio/Hero";
import { Capabilities } from "../components/portfolio/Capabilities";
import { Milestones } from "../components/portfolio/Milestones";
import { ClientMarquee } from "../components/portfolio/ClientMarquee";
import { Timeline } from "../components/portfolio/Timeline";
import { ContactFooter } from "../components/portfolio/ContactFooter";

export default function Portfolio() {
  useLenis();

  return (
    <div className="grain relative bg-[#050b14] text-white" data-testid="portfolio-root">
      <Nav />
      <main>
        <Hero />
        <Capabilities />
        <Milestones />
        <ClientMarquee />
        <Timeline />
        <ContactFooter />
      </main>
    </div>
  );
}
